import NextLink from 'next/link';
import Avatar from '@savvy-kit/components/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@savvy-kit/components/dropdown-menu';
import {
  SidebarFooter,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarSeparator,
  useSidebar,
} from '@savvy-kit/templates/sidebar';
import { ChevronsUpDown, LogOut, Settings } from 'lucide-react';
import { TrackedDropdownMenuItem } from 'src/components/tracked';
import { handleMutationError } from 'src/utils/handle-mutation-error';

import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';

function AdvisorSideNavFooter() {
  const { logout, user } = useAuth();
  const { state } = useSidebar();
  const isSideNavExpanded = state === 'expanded';

  const handleLogout = async (): Promise<void> => {
    try {
      await logout();
      window.location.href = '/login';
    } catch (err) {
      console.error(err);
      handleMutationError(err, 'Unable to logout.');
    }
  };

  return (
    <SidebarFooter className="relative">
      <SidebarSeparator className="absolute top-0 left-0 right-0" />
      <SidebarMenu>
        <SidebarMenuItem>
          <DropdownMenu>
            <DropdownMenuTrigger
              render={
                <SidebarMenuButton
                  size="lg"
                  aria-label={`${user?.firstName?.[0] ?? ''}${user?.lastName?.[0] ?? ''} ${user?.firstName} ${user?.lastName} ${user?.email}`}
                />
              }
            >
              <Avatar imageUrl={user?.profilePicUrl} firstName={user?.firstName} lastName={user?.lastName} />
              <div className="flex items-center gap-2 min-w-0 flex-1">
                <div className="flex flex-col min-w-0 flex-1">
                  <span className="text-sm font-semibold truncate">{`${user?.firstName} ${user?.lastName}`}</span>
                  <span className="text-xs truncate">{user?.email}</span>
                </div>
                <ChevronsUpDown className="size-4 shrink-0" />
              </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              className="w-56 rounded-md"
              align="end"
              side="right"
              sideOffset={isSideNavExpanded ? 12 : 24}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <DropdownMenuLabel className="text-secondary text-xs">Settings</DropdownMenuLabel>
              <DropdownMenuItem>
                <NextLink href="/advisor/dashboard/settings" className="flex items-center gap-2 w-full">
                  <div className="flex size-6 items-center justify-center rounded-xs border border-light bg-white">
                    <Settings className="size-4" />
                  </div>
                  <div>Settings</div>
                </NextLink>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <TrackedDropdownMenuItem
                elementName="account-popover-logout-button"
                className="gap-2 p-2"
                onClick={handleLogout}
              >
                <div className="flex size-6 items-center justify-center rounded-xs border border-light bg-white">
                  <LogOut className="size-4" />
                </div>
                <div>Log Out</div>
              </TrackedDropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarFooter>
  );
}

export default AdvisorSideNavFooter;
